<template>
    <div id="newMiniFilterPreview">
        <div
            class="title"
            v-tippy="{ followCursor: true, placement: 'bottom-end', delay: [500, 0] }"
            :content="getTitle()"
        >
            <span>
                {{ getTitle() }}
            </span>
            <span class="material-icons" style="font-size: 16px; cursor: pointer" @click="deleteFilter"> close </span>
        </div>
        <template v-if="!IGNORE_TYPES.includes(filter.rule)">
            <div v-if="selectedFilter.type === 'contact-property-selector'" class="dropdown-picker">
                <ContactPropertySelectorInline v-model="filter.value" :propertyId="filter.input" />
            </div>
            <div v-else-if="selectedFilter.type === 'country-selector'" class="dropdown-picker">
                <CountrySelectorInline v-model="filter.value" />
            </div>
            <div v-else-if="selectedFilter.type === 'city-selector'" class="dropdown-picker">
                <CitySelectorInline v-model="filter.value" />
            </div>
            <div v-else-if="selectedFilter.type === 'browser-selector'" class="dropdown-picker">
                <BrowserSelectorInline v-model="filter.value" />
            </div>
            <div v-else-if="selectedFilter.type === 'os-selector'" class="dropdown-picker">
                <OSSelectorInline v-model="filter.value" />
            </div>
            <div v-else-if="selectedFilter.type === 'platform-selector'" class="dropdown-picker">
                <PlatformSelectorInline v-model="filter.value" :multiple="selectedFilter.multiple" />
            </div>
            <div v-else-if="selectedFilter.type === 'select'" class="dropdown-picker">
                <a-select
                    v-model="filter.value"
                    :mode="selectedFilter.multiple ? 'multiple' : 'default'"
                    style="width: 100%"
                >
                    <a-select-option
                        v-for="option of selectedFilter.options"
                        :key="option.key"
                        :value="option.key"
                        style="display: flex; align-items: center"
                    >
                        {{ option.value }}
                    </a-select-option>
                </a-select>
            </div>
            <div v-else-if="selectedFilter.type === 'input'" class="input-picker" style="margin-top: 3px">
                <a-input v-model="filter.value" style="width: 100%" />
            </div>
            <div v-else-if="selectedFilter.type === 'date-select'" class="date-select-picker" style="margin-top: 3px">
                <DateSelectorInline v-model="filter.value" />
            </div>
        </template>
    </div>
</template>

<script>
import SupsisIcon from "../../Chatbot/pages/integrations/svg/SupsisIcon.vue";
import WhatsappIcon from "../../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import TelegramIcon from "../../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import MessengerIcon from "../../Chatbot/pages/integrations/svg/MessengerIcon.vue";
import InstagramIcon from "../../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import webIcon from "./svg/WebIcon.vue";
import mailIcon from "../../Mail/icons/MailIcon.vue";
import MetaIcon from "../../Chatbot/pages/integrations/svg/MetaIcon.vue";
import TrendyolIcon from "../../Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import CountrySelectorInline from "./CountrySelectorInline.vue";
import PlatformSelectorInline from "./PlatformSelectorInline.vue";
import ContactPropertySelectorInline from "./ContactPropertySelectorInline.vue";
import DateSelectorInline from "./DateSelectorInline.vue";
import BrowserSelectorInline from "./BrowserSelectorInline.vue";
import OSSelectorInline from "./OSSelectorInline.vue";
import CitySelectorInline from "./CitySelectorInline.vue";

const OPERATORS_TYPES = {
    is: "Eşit",
    is_not: "Eşit Değil",
    contains: "İçerir",
    not_contains: "İçermez",
    starts_with: "ile Başlar",
    ends_with: "ile Biter",
    is_empty: "Boş ise",
    is_not_empty: "Boş Değil ise",
    less_than: "Küçük",
    less_or_equal: "Küçük veya Eşit",
    greater_than: "Büyük",
    greater_or_equal: "Büyük veya Eşit",
};

const IGNORE_TYPES = ["is_empty", "is_not_empty"];

export default {
    name: "NewMiniFilterPreview",
    props: {
        filters: {
            type: Array,
            default: () => [],
        },
        filter: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        CitySelectorInline,
        OSSelectorInline,
        BrowserSelectorInline,
        DateSelectorInline,
        ContactPropertySelectorInline,
        PlatformSelectorInline,
        CountrySelectorInline,
        TrendyolIcon,
        MetaIcon,
        WhatsappIcon,
        TelegramIcon,
        MessengerIcon,
        webIcon,
        mailIcon,
        InstagramIcon,
        SupsisIcon,
    },
    data: () => ({
        IGNORE_TYPES,
        OPERATORS_TYPES,
    }),
    computed: {
        selectedFilter() {
            return this.filters.find((f) => f.key === this.filter.key);
        },
    },
    methods: {
        getTitle() {
            const rootName = this.selectedFilter.name;
            const inputName = this.getValue();
            const operator = OPERATORS_TYPES[this.filter.rule] || "";
            return `${rootName} ${inputName} ${operator}`;
        },
        deleteFilter() {
            this.$emit("deleteFilter");
        },
        getValue() {
            const selectedFilter = this.selectedFilter;
            if (selectedFilter.type === "contact-property-selector") {
                const option = selectedFilter.options.find((o) => o.key === this.filter.input);
                return option ? option.value : "";
            }
            if (selectedFilter.optionSelect && Array.isArray(selectedFilter.options) && this.filter.input) {
                const option = selectedFilter.options.find((o) => o.key === this.filter.input);
                return option ? option.value : "";
            }
            return "";
        },
    },
};
</script>
<style lang="scss">
#newMiniFilterPreview {
    .ant-calendar-picker {
        width: 100% !important;
    }

    .title {
        font-weight: 500;
        font-size: 13px;
        display: flex;
        gap: 8px;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        padding: 8px 0px;

        span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #1e1e2d;
            flex: 1;
        }

        .material-icons {
            font-size: 16px;
            color: #8c8c8c;
            cursor: pointer;
            transition: all 0.2s ease;
            flex-shrink: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            min-width: 20px;
            max-width: 20px;
            border-radius: 4px;
            line-height: 1;
            padding: 0;
            margin: 0;

            &:hover {
                color: #ffffff;
                background: #ff4d4f;
            }
        }
    }

    .dropdown-picker,
    .date-select-picker,
    .input-picker {
        display: flex;
        flex-direction: column;
        margin-bottom: 8px;

        .ant-select,
        .ant-input,
        .ant-calendar-picker {
            border-radius: 6px;
            border-color: #e8e8e8;
            transition: all 0.2s ease;

            &:hover {
                border-color: #5625CC;
            }

            &:focus,
            &.ant-select-focused {
                border-color: #5625CC;
                box-shadow: 0 0 0 2px rgba(86, 37, 204, 0.1);
            }
        }
    }
}

.option-wrapper {
    display: flex;
    align-items: center;
    gap: 7px;

    .option-icon {
        height: 20px;
        width: 20px;
        padding: 0;
    }

    .md-icon {
        margin: 0 !important;
        width: 19px;
        min-width: 19px;
        height: 19px;
    }
}
</style>
